import theme from '../../../themes/green';

const styles = {
  wrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 500,
    color: theme.pallete.lightTextColor,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/UIKit/Label/styles.js